<template>
    <div class="block">
        <form @submit.prevent="loadBeneficiaries">
            <div class="field has-addons">
                <p class="control">
                    <span class="select">
                        <select v-model="searchBy">
                            <option value="id">ID</option>
                            <option value="nric">NRIC</option>
                            <option value="full_name">Name</option>
                            <option value="unit">Unit</option>
                        </select>
                    </span>
                </p>

                <div class="control is-expanded">
                    <input v-if="searchBy == 'id'" v-model="searchTerm" class="input" type="number" inputmode="numeric" />
                    <input v-else v-model="searchTerm" class="input" type="text" />
                    <p v-if="searchBy == 'full_name'" class="help">Substring match. Case insensitive. Min 3 characters.</p>
                    <p v-else-if="searchBy == 'nric' || searchBy == 'unit'" class="help">Starts with. Case Sensitive.</p>
                </div>
                <div class="control">
                    <button :disabled="!searchTerm || (searchBy === 'full_name' && searchTerm.trim().length < 3)" class="button is-info">
                        Search
                    </button>
                </div>

            </div>
        </form>
    </div>

    <base-spinner v-if="isLoading"></base-spinner>

    <div class="block">
        <div v-if="searchPerformed && beneficiaries.length === 0" class="notification is-info is-light">
            <h3>No Beneficiary Found!</h3>
        </div>
        <div v-else class="table is-fullwidth is-striped">
            <BeneficiaryResult v-for="beneficiary in beneficiaries" :key="beneficiary.id" :id="beneficiary.id"
                :isBeneficiaryActive="beneficiary.active" :nric="beneficiary.nric" :beneficiaryName="beneficiary.full_name"
                :selfCollection="beneficiary.self_collection" :drivingDelivery="beneficiary.driving_delivery"
                :unit="beneficiary.unit" :block="beneficiary.block" :street="beneficiary.street">
            </BeneficiaryResult>
        </div>
    </div>
    <div v-if="!!error" class="notification is-danger is-light">
        <p>{{ error }}</p>
    </div>
</template>

<script>
import BeneficiaryResult from './BeneficiaryResult.vue';

export default {
    data() {
        return {
            isLoading: false,
            error: null,
            searchBy: 'id',
            searchTerm: '',
            searchPerformed: false
        }
    },
    components: {
        BeneficiaryResult,
    },
    computed: {
        beneficiaries() {
            return !this.isLoading && this.$store.getters['beneficiary/getBeneficiaries'];
        }
    },
    methods: {
        async loadBeneficiaries() {
            this.error = null;
            this.isLoading = true;
            try {
                await this.$store.dispatch('beneficiary/loadBeneficiaries', {
                    searchBy: this.searchBy,
                    searchTerm: this.searchTerm
                });
            } catch (error) {
                this.error = error.message || 'Something went wrong!';
            }
            this.isLoading = false;
            this.searchPerformed = true;
        }
    }
}
</script>
